var render = function render(){var _vm=this,_c=_vm._self._c;return _c('legend-map',{ref:"legendMapRef",attrs:{"legend-code":"zone_metering_legend","forbidden-list":['水厂范围'],"default-pitch-on":['片区范围示意图', '管线', '水厂范围', '分界阀门', '分区计量仪表']},on:{"layer-click":_vm.handleLayerClick,"selected-id-change":_vm.handleSelectedIdChange,"legend-toggle":_vm.handleLegendToggle}})
}
var staticRenderFns = []

export { render, staticRenderFns }